/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../../runtime';
import type { ChannelResponseDto, ProblemDetails } from '../models';
import {
    ChannelResponseDtoFromJSON,
    ChannelResponseDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

/**
 * ChannelApi - interface
 *
 * @export
 * @interface ChannelApiInterface
 */
export interface ChannelApiInterface {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelApiInterface
     */
    listAllAdChannelsAndTheirAdFormatsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<ChannelResponseDto>>>;

    /**
     */
    listAllAdChannelsAndTheirAdFormats(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<ChannelResponseDto>>;
}

/**
 *
 */
export class ChannelApi extends runtime.BaseAPI implements ChannelApiInterface {
    /**
     */
    async listAllAdChannelsAndTheirAdFormatsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<ChannelResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/channels`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(ChannelResponseDtoFromJSON),
        );
    }

    /**
     */
    async listAllAdChannelsAndTheirAdFormats(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<ChannelResponseDto>> {
        const response = await this.listAllAdChannelsAndTheirAdFormatsRaw(initOverrides);
        return await response.value();
    }
}
